export default __webpack_public_path__ + "static/media/offer-icon-unpublished.e8f1812a.svg";